import PropTypes from "prop-types";
export const Address = {
  addressKey: PropTypes.string,
  quickviewAddress: PropTypes.string,
  postcode: PropTypes.string,
  organisation: PropTypes.string,
  property: PropTypes.string,
  street: PropTypes.string,
  county: PropTypes.string,
  town: PropTypes.string
};